module.exports = __webpack_public_path__ + "images/scandinavian-4-06b57d664ca108d567338242da9591dd.jpg";